import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Layout from "./components/Layout";
import Home from "./Home";
import Servicos from "./Servicos";
import Sobre from "./Sobre";
import Contato from "./Contato";

export default function App() {
  return (
    // basename usa o valor de "homepage" do package.json automaticamente
    // (CRA expõe isso como process.env.PUBLIC_URL) — assim as rotas
    // (Link/NavLink) também respeitam a subpasta onde o site está publicado.
    <BrowserRouter basename={process.env.PUBLIC_URL}>
      <Routes>
        {/* Layout envolve todas as rotas: Header e Footer ficam fixos,
            e o Outlet dentro de Layout troca o conteúdo pela rota atual. */}
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="servicos" element={<Servicos />} />
          <Route path="sobre" element={<Sobre />} />
          <Route path="contato" element={<Contato />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
}
